import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useCurrentUser } from '../hooks/useCurrentUser';

export const RequireAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const user = useCurrentUser();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  } else {
    const perms = user.perms;

    if (location.pathname.includes("dupes") && !perms.dupes) {
      return <Navigate to={{ pathname: '/' }} replace />
    } else if ((location.pathname.includes("admin") || location.pathname.includes("companies")) && !perms.admin) {
      return <Navigate to={{ pathname: '/' }} replace />
    } else if (location.pathname.includes("import") && !perms.import) {
      return <Navigate to={{ pathname: '/' }} replace />
    } else if (location.pathname.includes("personas") && !(perms.p1 || perms.p2 || perms.p3)) {
      return <Navigate to={{ pathname: '/' }} replace />
    } else if (location.pathname.includes("personas/edit") && !(perms.p2)) {
      return <Navigate to={{ pathname: '/personas' }} replace />
    } else if (location.pathname.includes("content") && !(perms.c1 || perms.c2 || perms.c3)) {
      return <Navigate to={{ pathname: '/' }} replace />
    } else if (location.pathname.includes("content/edit") && !perms.c2) {
      if (!location.pathname.includes("/new") && perms.c1) {
        return <Navigate to={{ pathname: '/' }} replace />
      }
    }
  }

  return <>{children}</>;
}